<nav class="back-to-top" #backToTop aria-labelledby="back-to-top">
  <a
    (click)="scrollTop($event)"
    [core-analytics]="{ action: 'Back to top' }"
    aria-label="Back to top link"
    class="back-to-top__link"
    href="javascript:void(0);">
    <span [innerText]="'Back to top' | translate" class="sr-only" id="back-to-top"></span>
  </a>
</nav>
